const module = { name: 'movie/shared/heartsUI', exports: {} }; const exports = module.exports;



import { Fandango_revealable as Fandango_revealable_hide_unhide } from 'require-global';

const { hide, unhide } = Fandango_revealable_hide_unhide;


import { Fandango_adobeLaunch as Fandango_adobeLaunch_EventTypes_track } from 'require-global';

const { EventTypes, track } = Fandango_adobeLaunch_EventTypes_track;


import { default as $ } from 'swug-fdRequire-call:jQuery';



import { default as hearts } from 'swug-fdRequire-call:shared/utils/hearts';



const Selectors = {
    HEART_BTN: '.js-hearts-heart',
    PLACEHOLDER: '.js-favorite-heart-placeholder',
}
function attach() {
    hearts.init();
    $(Selectors.HEART_BTN).on('click', () => track({ event: EventTypes.FAVORITE_MOVIE_CLICKS })).attr('disabled', false);
    hide(Selectors.PLACEHOLDER);
    unhide(Selectors.HEART_BTN);
}
module.exports = {
    attach
};
export default module.exports;